import React, { createContext, useState, useCallback, useMemo, useContext } from 'react';
import { unitConversionsService } from '../services/UnitConversionsService';

export const UnitConversionsContext = createContext();

export const UnitConversionsProvider = props => {
    const [unitConversions, setUnitConversions] = useState([]);
    const [, setErr] = useState(null);
    const [total, setTotal] = useState(1);
    const [pageCount, setPageCount] = useState(1);

    const getUnitConversions = useCallback((sortState, page, pageSize) => {
        return unitConversionsService
            .getUnitConversions(sortState, page, pageSize)
            .then(res => {
                setUnitConversions(res?.data ?? []);
                setTotal(res?.total ?? 0);
                setPageCount(res?.page_count ?? 1);
            })
            .catch(err => setErr(err));
    }, []);

    const createUnitConversion = useCallback((unitConversion) => {
        return unitConversionsService
            .createUnitConversion(unitConversion)
            .then(res => {})
            .catch(err => { setErr(err); throw err; });
    }, []);

    const updateUnitConversion = useCallback((unitConversion) => {
        return unitConversionsService
            .updateUnitConversion(unitConversion)
            .then(res => {})
            .catch(err => { setErr(err); throw err; });
    }, []);

    const deleteUnitConversion = useCallback((sourceUnit, targetUnit) => {
        return unitConversionsService
            .deleteUnitConversion(sourceUnit, targetUnit)
            .then(res => {})
            .catch(err => { setErr(err); throw err; });
    }, []);

    const values = useMemo(
        () => ({
            unitConversions,
            total,
            pageCount,
            getUnitConversions,
            createUnitConversion,
            updateUnitConversion,
            deleteUnitConversion,
        }),
        [unitConversions, total, pageCount, getUnitConversions, createUnitConversion, updateUnitConversion, deleteUnitConversion]
    );

    return <UnitConversionsContext.Provider value={values}>{props.children}</UnitConversionsContext.Provider>;
};

export const useUnitConversions = () => {
    const context = useContext(UnitConversionsContext);

    if (context === undefined) {
        throw new Error('useUnitConversions must be used within a UnitConversionsProvider component.');
    }

    return context;
};
